var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"divii-logo",attrs:{"src":_vm.logoSrc,"alt":"Divii","width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }